import { Bill } from '@melio/platform-api';
import { min } from 'lodash';

export const getEarliestBillDueDate = (bills: Bill[]) => min(bills.map((bill) => bill.dueDate));
